import React from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { AgGridReact } from 'ag-grid-react';
import Grid from '@mui/material/Grid';
import { isPosted, headerColumns } from '../configuration/Utils';
import { useAuth } from '../context/AuthContext';
import Map from './Map';
import {
  API_URL_TENDER_OVERVIEW,
  API_URL_LANES_PRICING,
  tenderColumnsDefinitionOverview,
  API_URL_CLEANUP,
  API_URL_TENDERS_DELETE,
} from '../configuration/Configuration';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TableControls from '../integrations/core/table/TableControls';
import {
  applySavedColumnLayout,
  getColumnLayoutScope,
  saveGridColumnLayout,
} from '../integrations/core/table/columnLayoutPersistence';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { Modal, Box, Divider } from '@mui/material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  borderRadius: 1,

  display: 'flex',
  flexDirection: 'column',
  gap: 3,
};

const Admin = () => {
  window.addEventListener('beforeunload', () => {
    tenders = [];
  });
  const { key } = useLocation();

  useEffect(() => {
    resetState();
    getTenderDataOverview();
  }, [key]);

  // retrieve tender overview
  let [tenders, setOverview] = React.useState([]);
  // eslint-disable-next-line
  React.useEffect(() => {
    const opt = [];

    (async () => {
      const { data } = await axios.get(API_URL_TENDER_OVERVIEW);
      data.forEach((value) => {
        opt.push(value);
      });
    })();
    setOverview(opt);
  }, []);

  const getTenderDataOverview = () => {
    (async () => {
      const opt = [];
      const url_api = API_URL_TENDER_OVERVIEW;
      const { data } = await axios.get(url_api);
      data.forEach((value) => {
        opt.push(value);
      });
      setOverview(opt);
    })();
  };

  const gridRef = React.useRef();
  let fullScreenHandle = useFullScreenHandle();
  const gridStyle = React.useMemo(() => ({ height: 540, width: '100%' }), []);
  const overviewLayoutScope = getColumnLayoutScope();

  let [tendersSelectionState, setTenderSelectState] = React.useState(false);
  // eslint-disable-next-line
  let [tendersSelected, setTenderSelected] = React.useState(0);
  const detailLayoutScope = getColumnLayoutScope(tendersSelectionState ? tendersSelected : null);
  const [tenderData, setTenderData] = React.useState([]);
  const [gridAdmin, setGridAdmin] = React.useState([]);
  const persistColumnLayout = React.useCallback((event, layoutScope) => {
    saveGridColumnLayout(event.columnApi, layoutScope);
  }, []);
  const persistColumnLayoutOnResize = React.useCallback((event, layoutScope) => {
    if (!event.finished) {
      return;
    }

    saveGridColumnLayout(event.columnApi, layoutScope);
  }, []);
  const getTenderData = (tender) => {
    (async () => {
      const url_api = API_URL_LANES_PRICING + tender + '/admin';
      const { data } = await axios.get(url_api);
      setTenderData(data);

      let laneColumnDefinitionAdmin = await headerColumns(tender, true);
      setGridAdmin(laneColumnDefinitionAdmin);
    })();
  };
  const onTenderSelected = (params) => {
    setTenderSelected(params.data.id);
    getTenderData(params.data.id);
    setTenderSelectState(true);
  };
  const resetState = () => {
    setTenderSelectState(false);
  };

  const [cleanup, setCleanup] = React.useState(false);
  const [dbKey, setdbKey] = React.useState('');
  const [dbCKey, setdbCKey] = React.useState('');
  const [EXKey, setEXKey] = React.useState('');

  const cleanupButton = () => {
    setCleanup(true);
  };

  const cancelButton = () => {
    setCleanup(false);
    setdbKey('');
    setEXKey('');
    setdbCKey('');
  };

  const handledbKeyChange = (event) => {
    setdbKey(event.target.value);
  };
  const handleEXKeyChange = (event) => {
    setEXKey(event.target.value);
  };
  const handledbCKeyChange = (event) => {
    setdbCKey(event.target.value);
  };

  const cleanDB = async () => {
    let formData = { keyDB: dbKey };
    await axios
      .post(API_URL_CLEANUP, formData)
      .then((res) => console.log(res.data));
    setCleanup(false);
    setdbKey('');
    setEXKey('');
    setdbCKey('');
    getTenderDataOverview();
  };
  const cleanEX = async () => {
    let formData = { keyEX: dbKey };
    await axios
      .post(API_URL_CLEANUP, formData)
      .then((res) => console.log(res.data));
    setCleanup(false);
    setdbKey('');
    setEXKey('');
    setdbCKey('');
  };
  const cleanDBC = async () => {
    let formData = { keyDBC: dbCKey };
    await axios
      .post(API_URL_CLEANUP, formData)
      .then((res) => console.log(res.data));
    setCleanup(false);
    setdbKey('');
    setEXKey('');
    setdbCKey('');
    getTenderDataOverview();
  };

  const deleteTender = async () => {
    console.log('TENDER:', tendersSelected);
    let delData = { tender_id: tendersSelected };
    if (window.confirm('Do you really want to delete the tender?')) {
      if (window.confirm('Are you really sure?')) {
        setCleanup(false);
        setdbKey('');
        setEXKey('');
        setdbCKey('');
        setTenderSelectState(true);
        await axios
          .post(API_URL_TENDERS_DELETE, delData)
          .then((res) => console.log('Tender Deleted', res.data));
      }
    }
    resetState();
    getTenderDataOverview();
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {/* <Map></Map> - Doesn't seem to render anything? */}

        <FullScreen handle={fullScreenHandle}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <Typography variant="h6" align="left">
              Monitor the Status of your Tenders
            </Typography>

            <div>
              <TableControls
                table={gridRef}
                fullScreenHandle={fullScreenHandle}
                tenders={tendersSelectionState ? tendersSelected : undefined}
                layoutScope={tendersSelectionState ? detailLayoutScope : overviewLayoutScope}
              />
              {isPosted(!tendersSelectionState) && (
                <div style={gridStyle} className="ag-theme-alpine">
                  <AgGridReact
                    ref={gridRef} // Ref for accessing Grid's API
                    rowData={tenders} // Row Data for Rows
                    columnDefs={applySavedColumnLayout(
                      tenderColumnsDefinitionOverview,
                      overviewLayoutScope
                    )} // Column Defs for Columns
                    onColumnMoved={(event) =>
                      persistColumnLayout(event, overviewLayoutScope)
                    }
                    onColumnPinned={(event) =>
                      persistColumnLayout(event, overviewLayoutScope)
                    }
                    onColumnVisible={(event) =>
                      persistColumnLayout(event, overviewLayoutScope)
                    }
                    onColumnResized={(event) =>
                      persistColumnLayoutOnResize(event, overviewLayoutScope)
                    }
                    onRowDoubleClicked={onTenderSelected}
                    pagination={true}
                    paginationAutoPageSize={true}
                  />
                </div>
              )}
              {isPosted(tendersSelectionState) && (
                <div style={gridStyle} className="ag-theme-alpine">
                  <AgGridReact
                    ref={gridRef} // Ref for accessing Grid's API
                    rowData={tenderData?.rows} // Row Data for Rows
                    columnDefs={gridAdmin} // Column Defs for Columns
                    onColumnMoved={(event) =>
                      persistColumnLayout(event, detailLayoutScope)
                    }
                    onColumnPinned={(event) =>
                      persistColumnLayout(event, detailLayoutScope)
                    }
                    onColumnVisible={(event) =>
                      persistColumnLayout(event, detailLayoutScope)
                    }
                    onColumnResized={(event) =>
                      persistColumnLayoutOnResize(event, detailLayoutScope)
                    }
                    pagination={true}
                    paginationAutoPageSize={true}
                  />
                </div>
              )}
            </div>
          </div>
        </FullScreen>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            justifyContent: 'end',
          }}
        >
          {isPosted(tendersSelectionState) && (
            <Button
              variant="outlined"
              size="large"
              onClick={resetState}
              color="inherit"
            >
              Back
            </Button>
          )}
          {isPosted(!tendersSelectionState) && (
            <Button variant="outlined" size="large" disabled color="inherit">
              Back
            </Button>
          )}

          <Button
            variant="outlined"
            size="large"
            onClick={cleanupButton}
            color="inherit"
          >
            Cleanup
          </Button>
        </div>
      </div>

      {isPosted(cleanup) && (
        <Modal
          open={cleanup}
          onClose={() => {
            setEXKey('');
            setdbKey('');
            setdbCKey('');
            setCleanup(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...modalStyle, minWidth: 400 }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Administration
            </Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'end',
                alignItems: 'end',
                gap: 8,
              }}
            >
              <TextField
                label="Password Cleanup Database"
                type="password"
                variant="outlined"
                style={{ width: '100%' }}
                onChange={handledbKeyChange}
                value={dbKey}
              />
              <Button
                variant="contained"
                disabled={dbKey.length === 0}
                size="large"
                onClick={cleanDB}
                color="error"
                style={{ width: '100%' }}
              >
                Cleanup Database
              </Button>
            </div>

            <Divider />

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'end',
                alignItems: 'end',
                gap: 8,
              }}
            >
              <TextField
                label="Password Clear Database"
                type="password"
                variant="outlined"
                style={{ width: '100%' }}
                onChange={handledbCKeyChange}
                value={dbCKey}
              />

              <Button
                variant="contained"
                disabled={dbCKey.length === 0}
                size="large"
                onClick={cleanDBC}
                color="error"
                style={{ width: '100%' }}
              >
                Clear Database
              </Button>
            </div>

            <Divider />

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'end',
                alignItems: 'end',
                gap: 8,
              }}
            >
              <TextField
                label="Password Cleanup Export Files"
                type="password"
                variant="outlined"
                style={{ width: '100%' }}
                onChange={handleEXKeyChange}
                value={EXKey}
              />
              <Button
                variant="contained"
                disabled={EXKey.length === 0}
                size="large"
                onClick={cleanEX}
                color="error"
                style={{ width: '100%' }}
              >
                Cleanup Export Files
              </Button>
            </div>

            {isPosted(tendersSelectionState) && (
              <>
                <Divider />{' '}
                <Button
                  variant="contained"
                  color="warning"
                  size="large"
                  onClick={deleteTender}
                >
                  Delete tender
                </Button>
              </>
            )}
          </Box>
        </Modal>
      )}
    </div>
  );
};

export default Admin;
